// current v2
import { useMemo } from "react";

import { useMarketsInfoRequest } from "../markets";
import useSystemMetrics from "./useSystemMetrics";

export type DashboardOverview = {
  totalGMLiquidity: bigint;
  totalLongPositionSizes: bigint;
  totalShortPositionSizes: bigint;
  openInterest: bigint;
  dailyVolume: bigint;
  totalVolume: bigint;
  weeklyFees: bigint;
  epochFees: bigint;
  totalFees: bigint;
  totalUsers: bigint;
};

export default function useV2Stats(chainId: number): DashboardOverview {
  const systemMetrics = useSystemMetrics(chainId);
  const { marketsInfoData } = useMarketsInfoRequest(chainId);

  const stats = useMemo(() => {
    const allMarkets = Object.values(marketsInfoData || {}).filter((market) => !market.isDisabled);
    const totalLiquidity = allMarkets.reduce((acc, market) => {
      return acc + BigInt(market.poolValueMax ?? 0);
    }, 0n);

    const totalLongInterestUsd = allMarkets.reduce((acc, market) => {
      return acc + BigInt(market.longInterestUsd ?? 0);
    }, 0n);

    const totalShortInterestUsd = allMarkets.reduce((acc, market) => {
      return acc + BigInt(market.shortInterestUsd ?? 0);
    }, 0n);

    return {
      totalGMLiquidity: totalLiquidity ?? 0n,
      totalLongPositionSizes: totalLongInterestUsd ?? 0n,
      totalShortPositionSizes: totalShortInterestUsd ?? 0n,
      openInterest:
        totalLongInterestUsd !== undefined && totalShortInterestUsd !== undefined
          ? totalLongInterestUsd + totalShortInterestUsd
          : 0n,
      dailyVolume: systemMetrics?.dailyVolume ?? 0n,
      totalVolume: systemMetrics?.totalVolume ?? 0n,
      weeklyFees: systemMetrics?.weeklyFees ?? 0n,
      epochFees: systemMetrics?.epochFees ?? 0n,
      totalFees: systemMetrics?.totalFees ?? 0n,
      totalUsers: systemMetrics?.totalUsers ?? 0n,
    };
  }, [marketsInfoData, systemMetrics]);

  return stats;
}
